import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutNavbarNoShadow = {
  factory: EElement({
    id: '197b5237-f896-76d9-6df0-33611b6c21f8',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('div'),
      styleBlockIds: EList([EText('16206d95-1708-b891-b571-ce95631f6b3f')]),
      children: EList([
        EElement({
          id: '8c974eff-e46a-7fc4-5e40-fe1bfa0cda9b',
          type: qualify(
            Plugins.name('Navbar'),
            Component.name('NavbarWrapper')
          ),
          data: ERecord({
            tag: EEnum('div'),
            navbar: ERecord({
              animation: EEnum('default'),
              collapse: EText('medium'),
              docHeight: EBoolean(false),
              duration: ENumber(400),
              easing: EEnum('ease'),
              easing2: EEnum('ease'),
              noScroll: EBoolean(false),
              type: EText('wrapper'),
            }),
            styleBlockIds: EList([
              EText('6c517708-22ef-610a-1935-304f3fd10088'),
            ]),
            temp: ERecord({
              navbar: ERecord({
                menu: EEnum('hide'),
              }),
            }),
            children: EList([
              EElement({
                id: '111d0b45-275f-3ae2-9510-72b0f1a75d76',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('0c6745cf-33e6-a573-1cb9-8c398a781509'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'dc45bd69-44a9-e86c-5262-8053655e740b',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d9243737-6519-27e3-5f94-48a95680754d'),
                        ]),
                        children: EList([
                          EElement({
                            id: '8c974eff-e46a-7fc4-5e40-fe1bfa0cda9d',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarBrand')
                            ),
                            data: ERecord({
                              navbar: ERecord({
                                type: EText('brand'),
                              }),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse('{"mode":"external"}'),
                              }),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('c447af01-1144-3fbb-1b22-b79b330b748d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c8b8aa04-b59a-f9f2-d9b5-e662d8e416d5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.companyLogoPlaceholder),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272ee9752a1077276c028d8"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8c974eff-e46a-7fc4-5e40-fe1bfa0cda9e',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarMenu')
                            ),
                            data: ERecord({
                              tag: EEnum('nav'),
                              navbar: ERecord({
                                type: EText('menu'),
                              }),
                              attr: ERecord({
                                role: EText('navigation'),
                              }),
                              styleBlockIds: EList([
                                EText('0a4327ab-4bc9-e91e-1ec2-996cd50f31d5'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '402620ef-dde3-623a-dc3b-84cea90957b5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('List')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('ul'),
                                    list: ERecord({
                                      type: EText('list'),
                                      unstyled: EBoolean(true),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'cfe307c0-b1df-129c-b26a-d6d560d3d3ac'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '402620ef-dde3-623a-dc3b-84cea90957b6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '8afa92bf-18e1-1e2d-9ef9-2e446347d698',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '8afa92bf-18e1-1e2d-9ef9-2e446347d699',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('About'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '402620ef-dde3-623a-dc3b-84cea90957b7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: 'e75aa759-b948-30b0-7c57-ef2f207ab591',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'e75aa759-b948-30b0-7c57-ef2f207ab592',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Feature'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '402620ef-dde3-623a-dc3b-84cea90957b8',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '262fac40-7df9-625e-bdc7-1b2474d896ab',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '262fac40-7df9-625e-bdc7-1b2474d896ac',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'User Examples'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '1006d2f8-da06-c8ce-350d-0b235f7a9cd5',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '76bba7e5-a178-0a3b-891f-5760f4614b7b',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Link')
                                              ),
                                              data: ERecord({
                                                button: EBoolean(false),
                                                eventIds: EList([]),
                                                link: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Basic'),
                                                    typeName('Link')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"mode":"external","url":"#"}'
                                                  ),
                                                }),
                                                block: EText(''),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '76bba7e5-a178-0a3b-891f-5760f4614b7c',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText('Pricing'),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'eabd9a58-397b-3cdf-4788-24e58176b7fc',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '57108072-4b38-932f-1bc5-46fa19546acc',
                                              type: qualify(
                                                Plugins.name('Dropdown'),
                                                Component.name(
                                                  'DropdownWrapper'
                                                )
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                dropdown: ERecord({
                                                  type: EText('wrapper'),
                                                }),
                                                attr: ERecord({
                                                  'data-hover': EBoolean(false),
                                                  'data-delay': ENumber(0),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '0728d15e-0237-1200-955a-3690717e22b3'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  dropdown: ERecord({
                                                    menu: EEnum('hide'),
                                                  }),
                                                }),
                                                children: EList([
                                                  EElement({
                                                    id: '57108072-4b38-932f-1bc5-46fa19546acd',
                                                    type: qualify(
                                                      Plugins.name('Dropdown'),
                                                      Component.name(
                                                        'DropdownToggle'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      dropdown: ERecord({
                                                        type: EText('toggle'),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '3899de5c-e452-4345-eecb-810516b0f7f6'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '57108072-4b38-932f-1bc5-46fa19546ace',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Icon'
                                                            ),
                                                            Component.name(
                                                              'Icon'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            widget: ERecord({
                                                              type: EText(
                                                                'icon'
                                                              ),
                                                              icon: EText(
                                                                'dropdown-toggle'
                                                              ),
                                                            }),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  'ce5a6fe5-43dd-d941-77d8-d02214336a9e'
                                                                ),
                                                              ]),
                                                            children: EList([]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '57108072-4b38-932f-1bc5-46fa19546acf',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'Block'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            tag: EEnum('div'),
                                                            text: EBoolean(
                                                              true
                                                            ),
                                                            children: EList([
                                                              EElement({
                                                                id: '57108072-4b38-932f-1bc5-46fa19546ad0',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resources'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '57108072-4b38-932f-1bc5-46fa19546ad1',
                                                    type: qualify(
                                                      Plugins.name('Dropdown'),
                                                      Component.name(
                                                        'DropdownList'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('nav'),
                                                      dropdown: ERecord({
                                                        type: EText('list'),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '16e55e89-b250-51f9-3973-7fe101c92560'
                                                        ),
                                                        EText(
                                                          'd7476783-9f65-933c-7c1b-3ee135b53baf'
                                                        ),
                                                        EText(
                                                          '765ebb9a-7c67-8b78-3c36-04a67e120ad7'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '57108072-4b38-932f-1bc5-46fa19546ad2',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '57108072-4b38-932f-1bc5-46fa19546ad3',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 1'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '57108072-4b38-932f-1bc5-46fa19546ad4',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '57108072-4b38-932f-1bc5-46fa19546ad5',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 2'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '57108072-4b38-932f-1bc5-46fa19546ad6',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownLink'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'link'
                                                              ),
                                                            }),
                                                            link: ELiteral({
                                                              name: qualify(
                                                                Plugins.name(
                                                                  'Basic'
                                                                ),
                                                                typeName('Link')
                                                              ),
                                                              value: JSON.parse(
                                                                '{"url":"#","mode":"external"}'
                                                              ),
                                                            }),
                                                            eventIds: EList([]),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '57108072-4b38-932f-1bc5-46fa19546ad7',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'String'
                                                                  )
                                                                ),
                                                                data: EText(
                                                                  'Resource Link 3'
                                                                ),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '35e27109-10b2-d40c-0376-4c1b78382960',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              '7eaeb850-ba72-ca30-1d30-50f76271bf84'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'fdbf1800-8275-0b0d-6a54-a07e471f7957',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '07a78eba-6e20-2930-3125-a3c23feabce4'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '4b6dff49-3c9e-5d30-3235-4d66e33c98b2',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Link')
                                                    ),
                                                    data: ERecord({
                                                      button: EBoolean(true),
                                                      eventIds: EList([]),
                                                      link: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Basic'),
                                                          typeName('Link')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"mode":"external","url":"#"}'
                                                        ),
                                                      }),
                                                      block: EText(''),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '5811e2db-f107-fb36-bedc-ae019c696e30'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '4b6dff49-3c9e-5d30-3235-4d66e33c98b3',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Get Started'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8c974eff-e46a-7fc4-5e40-fe1bfa0cdaa5',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarButton')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              navbar: ERecord({
                                type: EText('button'),
                              }),
                              styleBlockIds: EList([
                                EText('f2a4d0f4-6afc-44f5-843b-063d94fa1d5d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8c974eff-e46a-7fc4-5e40-fe1bfa0cdaa6',
                                  type: qualify(
                                    Plugins.name('Icon'),
                                    Component.name('Icon')
                                  ),
                                  data: ERecord({
                                    widget: ERecord({
                                      type: EText('icon'),
                                      icon: EText('nav-menu'),
                                    }),
                                    children: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '16206d95-1708-b891-b571-ce95631f6b3f',
      type: 'class',
      name: 'Navbar No Shadow',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '6c517708-22ef-610a-1935-304f3fd10088',
      type: 'class',
      name: 'Navbar No Shadow Container',
      comb: '',
      styleLess:
        'z-index: 5; width: 100%; max-width: 1140px; margin-right: auto; margin-left: auto; padding-top: 20px; padding-right: 20px; padding-bottom: 20px; padding-left: 20px; background-color: transparent;',
      children: [],
      variants: {},
    },
    {
      _id: '0c6745cf-33e6-a573-1cb9-8c398a781509',
      type: 'class',
      name: 'Container Regular',
      comb: '',
      styleLess:
        'width: 100%; max-width: 1260px; min-height: 30px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {},
    },
    {
      _id: 'd9243737-6519-27e3-5f94-48a95680754d',
      type: 'class',
      name: 'Navbar Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'c447af01-1144-3fbb-1b22-b79b330b748d',
      type: 'class',
      name: 'Navbar Brand',
      comb: '',
      styleLess: '',
      children: [],
      variants: {small: {styleLess: 'padding-left: 0px;'}},
    },
    {
      _id: '0a4327ab-4bc9-e91e-1ec2-996cd50f31d5',
      type: 'class',
      name: 'Nav Menu Wrapper',
      comb: '',
      styleLess: '',
      children: [],
      variants: {medium: {styleLess: 'background-color: transparent;'}},
    },
    {
      _id: 'cfe307c0-b1df-129c-b26a-d6d560d3d3ac',
      type: 'class',
      name: 'Nav Menu',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 0px; padding-bottom: 0px; padding-left: 0px; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'display: flex; padding-left: 0px; justify-content: space-around; flex-wrap: wrap; align-items: center; background-color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        tiny: {styleLess: 'flex-direction: column;'},
        small: {
          styleLess:
            'padding-bottom: 30px; padding-left: 0px; flex-direction: column;',
        },
      },
    },
    {
      _id: 'afc274d7-2178-837c-3ef8-2c663643cdf3',
      type: 'class',
      name: 'Nav Link',
      comb: '',
      styleLess:
        'margin-right: 5px; margin-left: 5px; padding-top: 5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; color: #1a1b1f; font-size: 14px; line-height: 20px; letter-spacing: 0.25px; text-decoration: none;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: inline-block; padding-top: 10px; padding-bottom: 10px;',
        },
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
        medium: {styleLess: 'padding-right: 5px; padding-left: 5px;'},
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '0728d15e-0237-1200-955a-3690717e22b3',
      type: 'class',
      name: 'Nav Dropdown',
      comb: '',
      styleLess: 'margin-right: 5px; margin-left: 5px;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: flex; flex-direction: column; align-items: center;',
        },
      },
    },
    {
      _id: '3899de5c-e452-4345-eecb-810516b0f7f6',
      type: 'class',
      name: 'Nav Dropdown Toggle',
      comb: '',
      styleLess:
        'padding-top: 5px; padding-right: 30px; padding-bottom: 5px; padding-left: 10px; font-size: 14px; line-height: 20px; letter-spacing: 0.25px;',
      children: [],
      variants: {
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
        small: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: 'ce5a6fe5-43dd-d941-77d8-d02214336a9e',
      type: 'class',
      name: 'Nav Dropdown Icon',
      comb: '',
      styleLess: 'margin-right: 10px;',
      children: [],
      variants: {},
    },
    {
      _id: '16e55e89-b250-51f9-3973-7fe101c92560',
      type: 'class',
      name: 'Nav Dropdown List',
      comb: '',
      styleLess:
        'border-top-left-radius: 12px; border-top-right-radius: 12px; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; background-color: white;',
      children: ['d7476783-9f65-933c-7c1b-3ee135b53baf'],
      variants: {
        main_open: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
      },
    },
    {
      _id: 'd7476783-9f65-933c-7c1b-3ee135b53baf',
      type: 'class',
      name: 'Shadow Three',
      comb: '&',
      styleLess: '',
      children: ['765ebb9a-7c67-8b78-3c36-04a67e120ad7'],
      variants: {
        medium_open: {styleLess: 'position: absolute;'},
        small_open: {styleLess: 'position: relative;'},
        small: {
          styleLess: 'box-shadow: 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05);',
        },
      },
    },
    {
      _id: '765ebb9a-7c67-8b78-3c36-04a67e120ad7',
      type: 'class',
      name: 'Mobile Shadow Hide',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {
        small: {
          styleLess:
            'box-shadow: none /* 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05) */;',
        },
      },
    },
    {
      _id: '7b01a192-9eeb-e158-44d6-4af2632c5926',
      type: 'class',
      name: 'Nav Dropdown Link',
      comb: '',
      styleLess: 'padding-top: 5px; padding-bottom: 5px; font-size: 14px;',
      children: [],
      variants: {
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: '7eaeb850-ba72-ca30-1d30-50f76271bf84',
      type: 'class',
      name: 'Mobile Margin Top 10',
      comb: '',
      styleLess: '',
      children: [],
      variants: {small: {styleLess: 'margin-top: 10px;'}},
    },
    {
      _id: '07a78eba-6e20-2930-3125-a3c23feabce4',
      type: 'class',
      name: 'Nav Button Wrapper',
      comb: '',
      styleLess: 'margin-left: 120px;',
      children: [],
      variants: {
        medium: {styleLess: 'width: 100%; margin-left: 0px;'},
        tiny: {styleLess: 'width: auto;'},
      },
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: 'f2a4d0f4-6afc-44f5-843b-063d94fa1d5d',
      type: 'class',
      name: 'Menu button',
      comb: '',
      styleLess: '',
      children: [],
      variants: {
        medium_open: {
          styleLess:
            'background-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        medium: {
          styleLess:
            'padding-top: 12px; padding-right: 12px; padding-bottom: 12px; padding-left: 12px;',
        },
      },
    },
  ],
} as const;
